// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2f_kTpP_SU"};
    if(module.hot) {
      // 1597843268491
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  